import {
  withResponsiveOptions,
  withBreakpointObserver,
  getClosestParent,
} from '@studiometa/js-toolkit';
import { MenuBtn, MenuList, Menu as MenuCore } from '@studiometa/ui';

/**
 * Menu class.
 */
export default class Menu extends withResponsiveOptions(withBreakpointObserver(MenuCore)) {
  static config = {
    ...MenuCore.config,
    emits: ['open', 'close'],
    options: {
      ...MenuCore.config.options,
      mode: {
        type: String,
        default: 'click',
        responsive: true,
      },
    },
    components: {
      MenuList,
      MenuBtn,
    },
  };
}
